import QuizPage from '../../../components/QuizPageNew2';
import historyImage from '../../../assets/history2/Ancient_Civilizations_-_Ancient_China.png';

export default function HistoryPagChinaGo() {
  return (
    <QuizPage
      title="History: Ancient China"
      subTopic="Ancient China"
      backgroundImage={historyImage}
      returnPath="/History-Ancient-China"
    />
  );
}
